import type { Prisma } from "@prisma/client";
import { SubRole } from "../users/users.internal.vars";
import { BrokerContactCreationSubRole, ContactCreationRoles, DuneContactCreationSubRole } from "./contacts.internal.vars";

export const contactCreationRoles = ["DUNE", "BROKER", "SYNDIC", "INSURER", "TPA"] as const;
export const contactCreationRolesMutable = [...contactCreationRoles];

export const contactCreationRolesLabels = {
	DUNE: "Dune",
	BROKER: "Apporteur",
	SYNDIC: "Syndic",
	INSURER: "Assureur",
	TPA: "TPA",
};

export const duneContactCreationSubRoles = [
	"DUNE_ADMIN",
	"DUNE_UNDERWRITER",
] as const satisfies SubRole[]

export const brokerContactCreationSubRoles = [
	"BROKER_ADMIN",
	"BROKER_GESTIONNAIRE",
] as const satisfies SubRole[];

export type BrokerSubRole = typeof brokerContactCreationSubRoles[number];

export const duneContactCreationSubRolesLabels = {
	DUNE_ADMIN: "Administrateur",
	DUNE_UNDERWRITER: "Souscripteur",
} as const satisfies Record<DuneContactCreationSubRole, string>;

export const brokerUserCreationSubRolesLabels = {
	BROKER_ADMIN: "Administrateur",
	BROKER_GESTIONNAIRE: "Gestionnaire",
} as const satisfies Record<BrokerContactCreationSubRole, string>;


export const isBrokerSubRole = (subRole: SubRole | null): subRole is BrokerContactCreationSubRole => {
	return subRole !== null && brokerContactCreationSubRoles.includes(subRole as BrokerContactCreationSubRole);
};

export const areContactRoleAndSubRoleCompatible = (
  role: ContactCreationRoles,
  subRole: SubRole | null
): boolean => {
  if (role === "DUNE") {
    return duneContactCreationSubRoles.includes(subRole as DuneContactCreationSubRole);
  }
  if (role === "BROKER") {
    return brokerContactCreationSubRoles.includes(subRole as BrokerContactCreationSubRole);
  }
	if (role === "SYNDIC") {
		return subRole === null
	}
	if (role === "INSURER") {
		return subRole === null
	}
	if (role === "TPA") {
		return subRole === null
	}
	throw new Error("Unknown role");
}

export const contactSelect = {
	id: true,
	email: true,
	firstname: true,
	lastname: true,
	awsAuthId: true,
	role: true,
	subrole: true,
	society: {
		select: {
			id: true,
			companyName: true,
			denomination: true,
			type: true
		},
	},
	isActive: true,
	hasActivatedAccount: true,
	accountCreationInvitationSentAt: true,
} satisfies Prisma.UserSelect;
